const MATCHERS_BY_TYPE = Object.freeze({
  contains: (pattern: string, url: string) => url.includes(pattern),
  notContains: (pattern: string, url: string) => !url.includes(pattern),
  exactly: (pattern: string, url: string) => url === pattern,
  notExactly: (pattern: string, url: string) => url !== pattern,
  startsWith: (pattern: string, url: string) => url.startsWith(pattern),
  endsWith: (pattern: string, url: string) => url.endsWith(pattern),
  regex: (pattern: string, url: string) => {
    return new RegExp(pattern).test(url);
  },
  legacy: (pattern: string, url: string) => {
    return new RegExp(pattern, 'i').test(url);
  },
});

type PageUrlEvent = {
  id: number;
  matchType:
    | 'exactly'
    | 'legacy'
    | 'contains'
    | 'notContains'
    | 'regex'
    | 'startsWith';
  pattern: string;
};

// `stripethirdparty` compiles both Stripe's Sprig wrapper and the upstream SDK,
// whose ambient `UserLeap` declarations conflict. Narrow `window` to the config
// slice we read here so URL filtering keeps using the real runtime shape.
type WindowConfig = {
  UserLeap?: {
    _config?: {
      pageUrlEvents?: PageUrlEvent[];
    };
  };
};

function checkUrlMatch(event: PageUrlEvent, url: string) {
  const {matchType, pattern} = event;
  const matcher = matchType
    ? MATCHERS_BY_TYPE[matchType]
    : MATCHERS_BY_TYPE.legacy;

  return matcher(pattern, url);
}

const shouldTrackUrl = (url: string): boolean => {
  const pageUrlEvents = (window as WindowConfig).UserLeap?._config
    ?.pageUrlEvents;

  if (pageUrlEvents && pageUrlEvents.length) {
    for (let i = 0; i < pageUrlEvents.length; i += 1) {
      if (checkUrlMatch(pageUrlEvents[i], url)) {
        return true;
      }
    }

    return false;
  }

  return true;
};

// Helper which ensures that only expected events are fired in Sprig
export const shouldTrackEvent = (
  event: string,
  metadata: Record<string, unknown> = {},
): boolean => {
  // We only want to track 'pageUrl' events which are configured through
  // the Sprig Dashboard to avoid unnecessary throughput and the noisy
  // 404 response Sprig will return.
  if (event === 'pageUrl') {
    return shouldTrackUrl(String(metadata?.url) ?? '');
  }

  return true;
};
